import React, { useEffect, useState } from 'react';
import { navbarRef } from './HeaderComponent';
import { useRouter } from 'next/router';
import { useDispatch, useStore } from '@globalStore/storeProvider';

import axios from 'axios';
import { JOB_BOARD_COMPILER_BASE_URL } from '@lib/api';
import DemoClassFormButton from '@components/local/courses/forms/demo-class-form/DemoClassFormButton';

import cn from 'classnames';
import woodStyleClockIcon from '@assets/bytes/clock-front-color.png';
import Image from 'next/image';
import { DateTimeFormatter } from '@utils/utils';
import { Primary } from 'stories/Button.stories';
import { sourceType } from '../widgets/ContactUs';

function EuroScholarship() {
  const [isStripOpen, setIsStripOpen] = useState(true);

  //   const { pathname } = useRouter();
  const router = useRouter();
  const { nextCohort } = useStore();

  const dispatch = useDispatch();

  const headerPosition =
    typeof window !== undefined &&
    window?.getComputedStyle?.(navbarRef.current)?.getPropertyValue('position');

  const closeStripBanner = () => {
    setIsStripOpen(false);
    dispatch({ type: 'SET_STRIP_BANNER', payload: false });
  };

  useEffect(() => {
    dispatch({ type: 'SET_STRIP_BANNER', payload: true });
  }, []);

  const openCallbackWidget = () => {
    dispatch({ type: 'SET_WIDGET_SOURCE', payload: sourceType.callback });
  };

  const handleNavigate = () => {
    router.push('/announcement');
  };

  return (
    <>
      {isStripOpen && (
        <>
          {/* Dektop */}
          <section className="sticky top-[4rem]  z-40 hidden h-[4rem] w-full items-center justify-evenly bg-[url('/assets/strips/web-gradient.png')] bg-cover font-satoshi-medium  text-[14px] font-medium leading-5 md:flex md:h-14 md:justify-center md:py-2 md:pr-0 md:text-sm">
            <div className="flex items-center justify-center gap-2">
              <div className={'flex items-center gap-2'}>
                <img src="/assets/strips/rocket-slant.png" alt="" className="ml-2 h-8" />
                <p className="self-start font-satoshi-medium text-[20px] ">
                  The AlmaBetter Euro Scholarship Test is{' '}
                  <span className="font-satoshi-bold text-[20px] text-red">LIVE!</span>
                </p>
              </div>
              <div className="flex items-center gap-2">
                <img src="/assets/strips/award.png" alt="" className=" h-6" />
                <p className="font-satoshi-medium text-[16px]">Big Rewards for Top 50 Achivers</p>
              </div>

              <div className={''}>
                <Primary
                  label={'Register Now!'}
                  // customStyle={' px-1 py-2'}
                  // size={'xl'}
                  onClick={handleNavigate}
                />
              </div>
            </div>
          </section>
          {/* Mobile */}
          <div className="sticky top-[4rem] z-40 grid h-auto w-full grid-rows-[1fr] bg-[url('/assets/strips/mob-gradient.png')] bg-cover p-2  md:hidden">
            <div className="flex items-center gap-2">
              <div className="grid place-items-center">
                <img
                  src="/assets/strips/rocket-straight.png"
                  alt=""
                  className="flex h-[3.5rem] items-center justify-center"
                />
              </div>

              <div className="flex flex-1 flex-col gap-0">
                <p className="self-start font-satoshi-medium text-[20px] leading-tight">
                  The AlmaBetter Euro Scholarship Test is{' '}
                  <span className="font-satoshi-bold text-[20px] text-red">LIVE!</span>
                </p>
              </div>

              <div className="flex items-center justify-center">
                <Primary label={'Register Now!'} onClick={handleNavigate} />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default EuroScholarship;

async function fetchUpcomingDemoClass() {
  const {
    data: { upcomingClass },
  } = await axios.get(`${JOB_BOARD_COMPILER_BASE_URL}/api/website/demo-class/upcoming`);

  return upcomingClass;
}
